import { DataTable } from "../../../../../../../shared/components/data-table/DataTable";
import { useTranslation } from "react-i18next";
import UpdateClientMarketDialog from "./UpdateClientMarketDialog";
import TableDeleteButton from "../../../../../../../shared/components/button/TableDeleteButton";
import TableHeaderSortingButton from "../../../../../../../shared/components/button/TableHeaderSortingButton";

const ClientMarketsTable = ({ data, onMarketEdition, onMarketDeletion }) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "code",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.markets.table.code")}
          />
        );
      },
    },
    {
      accessorKey: "name",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.markets.table.name")}
          />
        );
      },
    },
    {
      accessorKey: "description",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.markets.table.description")}
          />
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <UpdateClientMarketDialog
              market={data}
              onSubmitHandler={(formValues) =>
                onMarketEdition(data.id, formValues)
              }
            />
            <TableDeleteButton
              onClickHandler={() => onMarketDeletion(data.id)}
            />
          </div>
        );
      },
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default ClientMarketsTable;
